module.exports = __webpack_public_path__ + "img/3.2b39a894.jpg";